import { Divider, Space, Typography } from 'antd';
import { TaxType } from 'config/constants/global.constants';
import { DiscountType } from 'config/constants/order.constants';
import { OrderTranscription } from 'config/constants/transcription.constant';
import React from 'react';
import { Discount, Tax } from 'store/models/order.model';
import styles from './styles.module.scss';

const { Text, Title } = Typography;

type TotalizerProps = {
  taxes: Tax[];
  totalFormatted?: string;
  subTotalFormatted?: string;
  discounts: Discount[];
};

const Totalizer: React.FC<TotalizerProps> = ({ taxes, totalFormatted = '', subTotalFormatted = '', discounts }) => {
  return (
    <div className={styles['totalizer-card']}>
      <Space direction='vertical' size='small' style={{ width: '100%' }}>
        <div className={styles['row-item']}>
          <Text type='secondary'>{OrderTranscription.SUBTOTAL}</Text>
          <Text strong>{subTotalFormatted}</Text>
        </div>

        {taxes?.map((tax, index) => (
          <div key={`${tax.name}-${index}`} className={styles['row-item']}>
            <Text type='secondary' style={{ textTransform: 'capitalize' }}>
              + {tax.name?.toLowerCase()} {tax.taxType === TaxType.PERCENTAGE ? `(${tax.rate}%)` : ''}
            </Text>
            <Text type='secondary'>{tax.appliedAmountFormatted}</Text>
          </div>
        ))}

        {discounts?.map((discount, index) => (
          <div key={`${discount.name}-${index}`} className={styles['row-item']}>
            <Text type='secondary' style={{ textTransform: 'capitalize' }}>
              - {discount.name?.toLowerCase()} {discount.discountType === DiscountType.PERCENTAGE ? `(${discount.amount}%)` : ''}
            </Text>
            <Text type='secondary'>{discount.amountFormatted}</Text>
          </div>
        ))}

        <Divider style={{ margin: '12px 0' }} />
        <div className={styles['row-item']}>
          <Text strong style={{ fontSize: '16px' }}>
            {OrderTranscription.TOTAL}
          </Text>
          <Title level={4} style={{ margin: 0 }}>
            {totalFormatted}
          </Title>
        </div>
      </Space>
    </div>
  );
};

export default Totalizer;
